import React, { useState, useEffect } from 'react';
import logo from '../TBL Logo White.png';
import './TryEachWine.css';

const TryEachWine = ({ classVersion, onNext, onBack }) => {
  // Initialize with saved data or defaults
  const getInitialRatings = () => {
    const savedRatings = sessionStorage.getItem('wineRatings');
    console.log('TryEachWine: Loading saved ratings:', savedRatings);
    if (savedRatings) {
      try {
        const parsedRatings = JSON.parse(savedRatings);
        console.log('TryEachWine: Parsed ratings:', parsedRatings);
        return parsedRatings;
      } catch (error) {
        console.error('TryEachWine: Error parsing saved ratings:', error);
      }
    }
    return {
      wine1: 0,
      wine2: 0,
      wine3: 0
    };
  };

  const [wineRatings, setWineRatings] = useState(getInitialRatings);

  // Save ratings to session storage whenever they change
  useEffect(() => {
    console.log('TryEachWine: Saving ratings:', wineRatings);
    sessionStorage.setItem('wineRatings', JSON.stringify(wineRatings));
  }, [wineRatings]);

  const handleRatingChange = (wine, rating) => {
    setWineRatings(prev => ({
      ...prev,
      [wine]: rating
    }));
  };

  const handleNext = () => {
    onNext();
  };

  const wines = [
    { id: 'wine1', name: 'Wine 1' },
    { id: 'wine2', name: 'Wine 2' },
    { id: 'wine3', name: 'Wine 3' }
  ];

  return (
    <div className={`try-each-wine ${classVersion}-theme`}>
      <div className="wine-header">
        <button className="back-button" onClick={onBack}>
          ← Back to Navigation
        </button>
        <img src={logo} className="wine-logo" alt="TBL Logo" />
        <h1>Try Each Wine</h1>
        <p className="wine-description">
          Please try 1-2 sips of each wine and give it a score of 0-5 below. 
          0 = dislike very much and 5 = like very much.
        </p>
      </div>

      <div className="wines-container">
        {wines.map((wine) => (
          <div key={wine.id} className="wine-rating-card">
            <h2 className="wine-name">{wine.name}</h2>
            <div className="rating-container">
                <div className="slider-container">
                  <input
                    type="range"
                    min="0"
                    max="5"
                    step="1"
                    value={wineRatings[wine.id]}
                    onChange={(e) => handleRatingChange(wine.id, parseInt(e.target.value))}
                    className="rating-slider"
                  />
                  <div className="slider-track"></div>
                  <div className="slider-ticks">
                    {[0, 1, 2, 3, 4, 5].map((tick) => {
                      // Browser formula: (value - min) / (max - min) * (trackWidth - thumbWidth) + thumbWidth/2
                      // For 0-5 range: (tick - 0) / (5 - 0) * (100% - thumbWidth) + thumbWidth/2
                      // Desktop: (tick / 5) * (100% - 28px) + 14px
                      // Mobile: (tick / 5) * (100% - 32px) + 16px
                      const desktopPosition = `calc(${(tick / 5) * 100}% - ${(tick / 5) * 28}px + 14px)`;
                      const mobilePosition = `calc(${(tick / 5) * 100}% - ${(tick / 5) * 32}px + 16px)`;
                      
                      return (
                        <div key={tick} className="slider-tick" style={{ 
                          left: desktopPosition,
                          '--mobile-position': mobilePosition
                        }}>
                          <div className="slider-tick-label">{tick}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              <div className="rating-value">
                <span className="current-rating">{wineRatings[wine.id]}</span>
                <span className="rating-text">
                  {wineRatings[wine.id] === 0 && 'Dislike very much'}
                  {wineRatings[wine.id] === 1 && 'Dislike'}
                  {wineRatings[wine.id] === 2 && 'Neutral'}
                  {wineRatings[wine.id] === 3 && 'Like'}
                  {wineRatings[wine.id] === 4 && 'Like very much'}
                  {wineRatings[wine.id] === 5 && 'Love'}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="action-buttons">
        <button className="next-button" onClick={handleNext}>
          Continue to Next Section
        </button>
      </div>

      <div className="footer">
        <div className="footer-separator"></div>
        <img src={logo} className="footer-logo" alt="TBL Logo" />
      </div>
    </div>
  );
};

export default TryEachWine;
